module.exports = __webpack_public_path__ + "img/ArBC-logo.08fe6fec.png";